import React from 'react'
import { useParams } from 'react-router-dom'
import { useGetTagByIdQuery, useUpdateTagMutation } from '../Service/tagsApi'
import { Tag } from '../Types/tagsType'
import { useEntityForm } from '../../Shared/Hooks/useEntityForm';
import { tagFields } from '../fields'
import { TagsRoutes } from '../../../Router/path'
import { FormRenderGroupTypes } from '../../Shared/Components/FormRenderer/FormRenderGroup.types'
import theme from '../../../theme'
import InfoIcon from '@mui/icons-material/Info';
import { CircularProgress, Typography } from '@mui/material'
import EntityFormLayout from '../../Shared/Components/EntityFormLayout/EntityFormLayout'
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const EditTag = () => {
    const tagId = parseInt(useParams<{ tagId: string }>().tagId!)
    const { data: tagData, isLoading: isTagLoading, error: tagError } = useGetTagByIdQuery(tagId, {
        skip: isNaN(tagId)
    })

    const [updateTag, updateStatus] = useUpdateTagMutation()

    const entityForm = useEntityForm<Tag>({
        initialData: tagData ?? { id: 0, name: '' },
        fields: tagFields,
        submitFn: (data) => updateTag({ id: tagId, data }).unwrap(),
        redirectUrl: TagsRoutes.root,
        title: 'Edytuj tag',
        icon: <LocalOfferIcon />,
        backUrl: TagsRoutes.root,
        mutationStatus: updateStatus,
        groupOrder: [FormRenderGroupTypes.basic],
        groupIcons: {
            Podstawowe: <InfoIcon sx={{ color: theme.palette.primary.main }} />,
        }
    })

    if (isTagLoading) {
        return (
            <Typography align="center" sx={{ mt: 4 }}>
                <CircularProgress />
            </Typography>
        );
    }

    if (tagError) {
        return (
            <Typography color="error" align="center" sx={{ mt: 4 }}>
                Nie udało się załadować danych tagu.
            </Typography>
        );
    }
    return (
        <><EntityFormLayout {...entityForm}></EntityFormLayout></>
    )
}

export default EditTag